import { render, staticRenderFns } from "./detail-factorycost.vue?vue&type=template&id=41b55265&scoped=true"
import script from "./detail-factorycost.vue?vue&type=script&lang=ts"
export * from "./detail-factorycost.vue?vue&type=script&lang=ts"
import style0 from "./detail-factorycost.vue?vue&type=style&index=0&id=41b55265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b55265",
  null
  
)

export default component.exports